export default function MinusIcon({ width = '16px', height = '16px' }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 14 2' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14 2L8.74228e-08 2L0 6.11959e-07L14 0V2Z'
        fill='#222731'
      />
    </svg>
  );
}
